import {LocalUser} from "src/typing";
import {createContext} from "react";


export interface UserContextType {
    current: LocalUser | null;
    fetch: () => LocalUser | null;
    authenticate: () => void;
    logout: () => void;
    authenticated: () => Promise<void>
}

const UserContext = createContext<UserContextType>(null as any)

export default UserContext;